<template>
  <div class="data-parameter">
    <div class="data-top">
      <div class="data-p-tit">
        <span>大数据分析（累计数据）</span>
      </div>
      <div style="display: flex;">
        <div class="data-total-left">
          <div class="data-total">
            <span class="data-blue-tit">补贴机具监管（台）</span>
            <p class="data-white-num">{{paradata.discountMonTotal||0}}</p>
          </div>
          <!-- <el-tooltip class="data-total" :content="expectTitle" placement="top"> -->
          <div class="data-area">
            <span class="data-blue-tit">补贴机具审核（台）</span>
            <p class="data-blue-num">{{paradata.agrMonTotal||0}}</p>
          </div>
          <!-- </el-tooltip> -->
        </div>
        <div class="data-total-right">
          <div class="data-total">
            <span class="data-blue-tit">预警机具监管（台）</span>
            <!-- <p class="data-white-num">{{paradata.earlyWarnMonTotal||0}}</p> -->
            <p class="data-white-num">{{this.subSum||0}}</p>
          </div>
          <!-- <el-tooltip class="data-total" :content="expectTitle" placement="top"> -->
          <div class="data-area">
            <span class="data-blue-tit">预计作业面积（亩）</span>
            <p class="data-blue-num">{{paradata.sumAreaTotal||0}}</p>
          </div>
          <!-- <el-tooltip class="data-total"  :content="spannedTitle" placement="top">
            <div>
              <span class="data-blue-tit">跨区机具监管（台）</span>
              <p class="data-white-num">{{paradata.spanAreaMonTotal||0}}</p>
            </div>
          </el-tooltip> -->
          <!--<div class="data-total" style="margin-top: -10px" content="Top center" placement="top" >
            <span class="data-blue-tit">跨区农机（台）</span>
            <p class="data-white-num">{{paradata.spanAreaMonTotal||0}}</p>
          </div>-->
          <!-- <el-tooltip class="data-total" :content="warningTitle" placement="top"> -->
            <!-- <div class="data-total">
              <span class="data-blue-tit">预警机具监管（台）</span>
              <p class="data-white-num">{{paradata.earlyWarnMonTotal||0}}</p>
            </div> -->
          <!-- </el-tooltip> -->
          <!--<div class="data-total" style="margin-top: 40px">
            <span class="data-blue-tit">预警农机（台）</span>
            <p class="data-white-num">{{paradata.earlyWarnMonTotal||0}}</p>
          </div>-->
          <!-- <div class="data-area">
            <span class="data-blue-tit" >补贴机具审核（台）</span>
            <p class="data-blue-num">{{paradata.agrMonTotal||0}}</p>
          </div> -->
        </div>
      </div>
    </div>
    <!--下侧数据-->
    <div class="cross-regional">
      <div class="data-p-tit">
        <span>跨区作业统计（当年数据）</span>
        <div class="data-parameter-table">
          <template>
            <table>
              <thead>
                <tr>
                  <td style="text-align: center;"></td>
                  <td style="text-align: center;">{{ countyOrCityName }}</td>
                  <td style="text-align: center;" v-if="cityShows">跨市作业</td>
                  <td class="kuaxian">跨县作业</td>
                </tr>
              </thead>
              <tbody>
              <tr class="trs">
                <td style="text-align: center;color: unset;font-size: unset;">农机数量</td>
                <td style="text-align: center;">{{this.regin.provinceNum||0}}</td>
                <td style="text-align: center;" v-if="cityShows">{{this.regin.cityNum||0}}</td>
                <td style="text-align: center;">{{this.regin.countyNum||0}}</td>
              </tr>
              <tr>
                <td style="text-align: center;color: unset;font-size: unset">累计作业面积</td>
                <td style="text-align: center;">{{this.regin.provinceArea||0}}</td>
                <td style="text-align: center;" v-if="cityShows">{{this.regin.cityArea||0}}</td>
                <td style="padding-right:10px;text-align: center;">{{this.regin.countyArea||0}}</td>
              </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import  Api from '../../../Serves/net-api.js'
  import Http from '../../../Serves/net-http.js'
  import {mapState,mapActions,mapMutations} from "vuex";
  export default {
    name: "DataParameter",
    data() {
      return {
        paradata:'', // 大数据分析
        regin:'', // 跨区作业
        cityName:'', // 地区名称
        spannedTitle:'当年跨区', // 跨区提示
        warningTitle:'当年预警', // 预警提示
        expectTitle:'当年预计作业', // 预计作业提示
        cityShows: false,
        countyOrCityName: '',
        subSum: ''
      }
    },
    beforeDestroy(){
      // 释放echars
      /*chart.clear()*/
      this.bus.$off('statue')
    },
    computed:{
      ...mapState({
        result:state=>state.result
      })
    },
    mounted(){
      this.cityName=this.result.areaName
      this.bus.$on("subSum", (mes) => {
				this.subSum = mes;
			});
      setTimeout(() => {
//    	this.subSum = this.$store.state.subSum
        this.getdata()
        this.cityShow()
        //监听省份变化
        this.bus.$on('statue',res=>{
          console.log(res)
          if(res.city!=this.propsState){
            if(res.city==='全国'){
              // console.log('////////')
              var url=Http.test+'/applicationSubsidy/statisticalByAreaCode'
              if (res.key === 'provName') {
                var data={
                  provCode:res.code
                }
              } else if (res.key === 'cityName') {
                var data={
                  cityCode: res.code
                }
              }
              Api.doPost(url,null,false,(res)=>{
                this.paradata=res.result
                this.regin=res.result
                //提示设置
                this.spannedTitle = '当年跨区农机' + res.result.spanAreaMonTotal+'(台)'
                this.warningTitle ='当年预警农机' + res.result.earlyWarnMonTotal+'(台)'
                this.expectTitle = '当年预计作业面积' + res.result.sumAreaTotal + '(亩)'
                /*this.getDevice()*/
              },(err)=>{
              })
              return
            }
            if(res.city=='切换'){
              console.log('nnnnnnnn')
              var url=Http.test+'/applicationSubsidy/statisticalByAreaCode'
              var areaNames = this.$store.state.areaName
              // 先判断首次请求那个层级数据
              if(areaNames ==='上海市'||areaNames==='北京市'||areaNames==='青岛市' || areaNames === '济南市' || areaNames==='天津市'||areaNames==='重庆市'||areaNames==='台湾') {
                  if(res.key=='provName'){
                    if(areaNames ==='上海市'||areaNames==='北京市'||areaNames==='青岛市' || areaNames === '济南市' || areaNames==='天津市'||areaNames==='重庆市'||areaNames==='台湾') {
                      var data={
                        countyCode: res.code
                      }
                    } else {
                      console.log('llllllllll')
                      var data={
                        cityCode: res.code
                      }
                    }
                  } else {
                    var data={
                      provCode: this.$store.state.Code
                    }
                  }
                  Api.doPost(url,null,false,(res)=>{
                    this.paradata=res.result
                    this.regin=res.result
                    //提示设置
                    this.spannedTitle = '当年跨区农机' + res.result.spanAreaMonTotal+'(台)'
                    this.warningTitle ='当年预警农机' + res.result.earlyWarnMonTotal+'(台)'
                    this.expectTitle = '当年预计作业面积' + res.result.sumAreaTotal + '(亩)'
                    /*this.getDevice()*/
                  },(err)=>{
                  })
                // })
              } else {
                console.log('bnnnnnnnnnnnn')
                if (res.seriesName ==='上海市'||res.seriesName==='北京市'||res.seriesName==='青岛市' || res.seriesName === '济南市' || res.seriesName==='天津市'||res.seriesName==='重庆市'||param.seriesName==='台湾') {
                  var data={
                    countyCode: res.code
                  }
                  Api.doPost(url,data,false,(res)=>{
                    this.paradata=res.result
                    this.regin=res.result
                    //提示设置
                    this.spannedTitle = '当年跨区农机' + res.result.spanAreaMonTotal+'(台)'
                    this.warningTitle ='当年预警农机' + res.result.earlyWarnMonTotal+'(台)'
                    this.expectTitle = '当年预计作业面积' + res.result.sumAreaTotal + '(亩)'
                    /*this.getDevice()*/
                  },(err)=>{
                  })
                } else {
                  return
                }
                
                // var data={
                //   provCode: this.$store.state.Code
                // }
                // Api.doPost(url,data,false,(res)=>{
                //   this.paradata=res.result
                //   this.regin=res.result
                //   //提示设置
                //   this.spannedTitle = '当年跨区农机' + res.result.spanAreaMonTotal+'(台)'
                //   this.warningTitle ='当年预警农机' + res.result.earlyWarnMonTotal+'(台)'
                //   this.expectTitle = '当年预计作业面积' + res.result.sumAreaTotal + '(亩)'
                //   /*this.getDevice()*/
                // },(err)=>{
                // })
              }
            } else {
              console.log('///////,,,,,')
              var url=Http.test+'/applicationSubsidy/statisticalByAreaCode'
              if(res.key=='provName'){
                console.log('0000000000')
                 if (this.$store.state.areaName === '青岛市' || this.$store.state.areaName === '济南市') {
                  var data={
                    cityCode: this.$store.state.Code
                  }
                } else {
                  var data={
                    provCode: this.$store.state.Code
                  }
                }
              }else {
                console.log('999999')
                var areaNames = this.$store.state.areaName
                // 先判断首次请求那个层级数据
                // if(areaNames ==='上海市'||areaNames==='北京市'||areaNames==='青岛市' || areaNames === '济南市' || areaNames==='天津市'||areaNames==='重庆市'||areaNames==='台湾') {
                  var data={
                    cityCode: res.city
                  }
                // } else {
                //   var data ={
                //     provCode: this.$store.state.Code
                //   }
                // }
              }
              //空闲环状图接口大数据展示
              Api.doPost(url,null,false,(res)=>{
                this.paradata=res.result
                this.regin=res.result
                //提示设置
                this.spannedTitle = '当年跨区农机' + res.result.spanAreaMonTotal+'(台)'
                this.warningTitle ='当年预警农机' + res.result.earlyWarnMonTotal+'(台)'
                this.expectTitle = '当年预计作业面积' + res.result.sumAreaTotal + '(亩)'
                /*this.getDevice()*/
              },(err)=>{
              })
            }
          }else {
            console.log('相同')
          }
        })
      }, 200)
    },
    methods:{
      // ...mapActions(['getAccountInfo']),
      cityShow () {
        var areaNames = this.$store.state.areaName
        // 先判断首次请求那个层级数据
        if(areaNames ==='上海市'||areaNames==='北京市'||areaNames==='青岛市' || areaNames === '济南市' || areaNames==='天津市'||areaNames==='重庆市'||areaNames==='台湾') {
          this.cityShows =  false
          this.countyOrCityName = '跨市作业'
        } else {
          this.cityShows =  true
          this.countyOrCityName = '跨省作业'
        }
      },
      // 首次请求全国数据
      getdata(){
        // if(this.$store.state.areaName ==='青岛市' || this.$store.state.areaName === '济南市') {
        //   var parmes={
        //     cityCode: this.$store.state.Code
        //   }
        // } else {
        //   var parmes={
        //     provCode:this.$store.state.Code
        //   }
        // }
        if (this.$store.state.Code === '11') {
          var parmes = {
            provCode: this.$store.state.Code
          }
        } else {
          var parmes = {
            countyCode: this.$store.state.Code
          }
        }
        var url=Http.test+'/applicationSubsidy/statisticalByAreaCode'
        Api.doPost(url,null,false,(res)=>{
          this.paradata=res.result
          this.regin=res.result
          // 提示设置
          this.spannedTitle = '当年跨区农机' + res.result.spanAreaMonTotal+'(台)'
          this.warningTitle ='当年预警农机' + res.result.earlyWarnMonTotal+'(台)'
          this.expectTitle = '当年预计作业面积' + res.result.sumAreaTotal + '(亩)'
        },(err)=>{
          console.log(err)
        })
      }
    }
  }
</script>

<style scoped>
.trs{
  height: 5.55vh;
}
.kuaxian{
  padding-right:5px;
  min-width: 100px;
  text-align: center;
}
  .data-p-tit span{
    font-size: 18px;
  }
  div{
    display: inline-block;
  }
  .data-top{
    width: 100%;
    height: 31vh;
    /* background: url("/static/img/data-p.png")no-repeat; */
    background: url("/static/img/left.png")no-repeat;
    background-size: 100% 100%;
    margin-top: 10px;
  }
  .data-parameter{
    height:100%;
  }
  .data-p-tit{
    width: 100%;
  }
  .data-p-tit span{
    margin-left: 20px;
    line-height: 5vh;
    float: left;
    color: #fff;
    font-size: larger;
  }
  .data-total{
    display: block;
    text-align: center;
    padding-top: 1vh;
  }
  .data-area{
    display: block;
    text-align: center;
    margin-top: 1vh;
    padding-top: 1vh;
    border-top: solid 1px #1f3668;
  }
  .data-blue-tit{
    line-height: 5vh;
    font-size: 18px;
  }
  .data-blue-num{
    color: #72BDED;
    font-size: 32px;
  }
  .data-total-left{
    width: 45%;
    margin-left: 5%;
    text-align: center;
    /* float: left; */
    border-right: solid 1px #1f3668;
  }
  .data-total-right{
    width: 45%;
    margin-right: 5%;
    /* float: right; */
    /* margin-top: -25px; */
  }
  .data-white-num{
    display: block;
    color: #fff;
    font-size: 30px;
  }
  .cross-regional{
    width: 100%;
    margin-top: 1vh;
    height: 21vh;
    background: url("/static/img/left-bot.png")no-repeat;
    background-size:100% 100%;
  }
  .data-parameter-table{
    width: 100%;
    /*min-width: 453px;*/
    padding-right: 10px;
  }
  .data-parameter-table thead tr td{
    width: 29%;
    /*font-size: large;*/
  }
  .data-parameter-table tbody tr td{
    color: #fff;
    font-size: 28px;
  }
  .el-table__header th, .el-table__header tr,.el-table td, .el-table th.is-leaf {
    background-color: #0b1640 !important;
    border-bottom: 0 !important;
  }
  .el-table--border::after, .el-table--group::after, .el-table::before{
    background-color: transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Subsidies/common/DataParameter.vue